import { AccountState } from 'src/app/store/account/account.reducer';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { selectError, selectLoading, selectUser, selectUserId } from 'src/app/store/account/account.selectors';
import { login, logout, signUp } from 'src/app/store/account/account.actions';
import { AngularFireAuth } from '@angular/fire/auth';
import { Update } from '@ngrx/entity';
import { User } from '../models/user.model';
import { from, Observable } from 'rxjs';
import { AngularFirestore } from '@angular/fire/firestore';
import { tap, switchMap, take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

  account$ = this.afa.user;
  user$ = this.store.select(selectUser);
  loading$ = this.store.select(selectLoading);
  error$ = this.store.select(selectError);
  userId$ = this.store.select(selectUserId);

  constructor(
    private store: Store<AccountState>,
    private afa: AngularFireAuth,
    private afs: AngularFirestore
  ) { }

  login(provider: string, credentials?: any) {
    this.store.dispatch(login({ provider, credentials }));
  }

  signUp(provider: string, credentials?: any) {
    this.store.dispatch(signUp({ provider, credentials }));
  }

  updateUser(update: Update<User>): Observable<void> {
    return from(this.afs.collection('users').doc(update.id as string).update(update.changes));
  }

  deleteUser(id: string): Observable<void> {
    return this.afa.user.pipe(
      take(1),
      switchMap(user => user.delete()),
      tap(() => this.logout())
    );
  }

  logout() {
    this.store.dispatch(logout());
  }

}
